import styled from "styled-components";
import { Button } from "react-bootstrap";

interface IBannerForwardButtonStyledProps {
    background?: string;
    color?: string;
}

export const BannerForwardButtonStyled = styled(Button)<IBannerForwardButtonStyledProps>`
    &.btn.btn-primary {
        &, &:focus, &:active, &:hover {
            background: ${({ background }) => background || 'var(--color-button-secondary-default)'};
            color: ${({ color }) => color || 'var(--color-label-primary-inverted)'};
            border-radius: 12px;
            border: none;
            padding: 12px;
        }
    }
`;
